// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"Uf-z","hidden":"Vf-z","preventTransition":"Wf-z","divBgImg":"Xf-z","loaded":"Yf-z"};